import { FormFieldTypes, validationTypes } from "@repo/design-system/components/forms/libs";

export const buildInitialFormConfig = () => ({
  name: "Complete Profile Form",
  initialState: {
    qualification: "",
    seatNumber: "",
    enrollmentNumber: "",
  },
  section: [
    {
      title: "Complete Profile Form",
      row: {},
      style: { sectionStyle: "" },
      rowGroup: [
        {
          groupLabel: "",
          style: { groupStyle: "row mb-2" },
          fields: [
            {
              id: "qualification",
              label: "Select Academic Qualification :",
              Field_Name: "qualification",
              fieldType: FormFieldTypes.SELECT,
              dataField: "qualification",
              fieldSetting: {
                placeholder: "Select qualification",
                options: [],
                isSearchable: false,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-md-6 col-12 mb-3" },
            },
            {
              id: "seatNumber",
              label: "Seat Number",
              Field_Name: "seatNumber",
              fieldType: FormFieldTypes.INPUT,
              dataField: "seatNumber",
              fieldSetting: {
                placeholder: "Enter seat number",
                maxLength: 30,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-md-6 col-12 mb-3" },
            },
            {
              id: "enrollmentNumber",
              label: "Enrollment No.",
              Field_Name: "enrollmentNumber",
              fieldType: FormFieldTypes.INPUT,
              dataField: "enrollmentNumber",
              fieldSetting: {
                placeholder: "Enter Enrollment No.",
                maxLength: 30,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-md-6 col-12 mb-3" },
            },
          ]
        }
      ]
    }
  ]
});


